export default __webpack_public_path__ + "static/extrait-rapport-audit-SEO-761d6c935013d0ea0a1f4ecc60d8fa83.png";